import type { GroupAnalysisData } from '@/generated/types/navigator/types.gen';
import { type Ref } from 'react';
import type { BoundingBoxString } from '@/features/types';
import { GroupItem } from './GroupItem';

export const ListItems = ({
  items,
  lastItemRef,
  onClick,
}: {
  items: GroupAnalysisData[];
  lastItemRef: Ref<HTMLDivElement>;
  onClick?: (bbox: BoundingBoxString | undefined, group?: string) => void;
}) => {
  const itemElements = items.map((item, idx) => {
    const itemDiv =
      items.length === idx + 1 ? (
        <GroupItem a={item} key={idx} ref={lastItemRef} onClick={onClick} />
      ) : (
        <GroupItem a={item} key={idx} onClick={onClick} />
      );
    return itemDiv;
  });

  return itemElements;
};
